import StatementOfInformationCard from './StatementOfInformationCard.component';

export default StatementOfInformationCard;